import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

interface DevModeStore {
  devMode: boolean

  setDevMode: (devMode: boolean) => void
}

export const useDevModeStore = create<DevModeStore>()(
  persist(
    immer((set) => ({
      devMode: import.meta.env.DEV,
      setDevMode: (devMode) => {
        set((state) => {
          state.devMode = devMode
        })
      },
    })),
    {
      name: 'dev-mode-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
